'use client'; // Error boundaries must be Client Components

import { useEffect } from "react";
import { runWhenSentryReady } from "@/shared/libs/sentry-ready-queue";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    runWhenSentryReady(({ captureException }) => captureException(error));
  }, [error]);

  return (
    // global-error must include html and body tags
    <html>
      <body>
        <h2>Something went wrong!</h2>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  );
}
